import * as React from 'react';
import './style.css';
import styles from "../index.css"
import Pic from './picture.jpg';
import Typewriter from 'typewriter-effect';
import { BrowserRouter, Routes, Route,Link } from "react-router-dom";
import {Helmet} from "react-helmet";

function Home() {

  return (
    <>

<Helmet>
  <meta charSet="utf-8" />
  <title>Home Nabeel-R</title>
  <link rel="canonical" href="http://nabeel-r.netlify.app" />
  <meta name="description" content="Nabeel-R: My expertise is in technology. I am passionate about technology. I am proficient in ML, Web Dev, App Dev, Coding, Data Science." />
</Helmet>

<div>

<br/>


      <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3">         {/* Grid of Page */}
        <div className="flex justify-center w-full lg:col-span-1 background-left">          {/* Left Column */}
<div>
<br/>


<center>    <img className='dp' width='300' height='300' src={Pic} />  </center>

<br/><br/>

<center>
<h1 className='title white'>

<Typewriter 
  onInit={(typewriter) => {
    
    typewriter.typeString(
   "I am a <strong><b>Coder</b></strong>"
    )
      .pauseFor(1800)
      .changeDeleteSpeed(200)
      .deleteChars(5)
      typewriter.typeString(
        "<strong><b>Developer</b></strong>"
         )
      .pauseFor(1800)
      .changeDeleteSpeed(200)
      .deleteChars(9)
      typewriter.typeString(
        "<strong><b>Engineer</b></strong"
         )
      .pauseFor(1800)
      .changeDeleteSpeed(200)
      .deleteChars(8)
      typewriter.typeString(
        "<strong><b>Programmer</b></strong>"
         )
        .start();
  }}

/>

</h1>
</center>


<div>

<br/>
<br/>

<center>
<a className="OffButton" href="https://www.linkedin.com/in/nabeel-riz/"> <span>Linkedin</span></a>
</center>

<br/>

<br/>

<center>
<a className="OffButton" href="mailto:nabeel.rizwan.50@outlook.com"> <span>Email</span></a>
</center>

<br/><br/>

<center>
<a className='Button pointer' href="https://github.com/Nabeel-Rizwan">Github</a>
</center>

<center>
<div className="grey mt-10 mx-5">Feel free to contact me for any query, collaboration or service.</div>
</center>

<br/>
<br/>

<center>
<Link className='Button pointer' to="/QR">Share</Link>
</center>




</div>
<br/><br/><br/>
        </div>
        
        </div>



 {/* Right Column Grid */}

        <div className='flex justify-center bg-[#0F1114] w-full lg:col-span-2 sm:w-full'>    
        <div className="para">


<div>
<br/>

<h1 className="white title">Nabeel M Rizwan</h1>   
<br/>
<p><span className='grey sentence'>Trying to connect the World</span></p>


</div>  

{/* Hover Card, Hover over share button, to close Hover card either hover over card or use red dot button */}


<br/><br/>

<div className="txt sentence mr-5">

I'm a tech enthusiast dedicated to leveraging technology and knowledge to make a positive impact on the world.
<br/>
My expertise is in technology. With every line of code, I try to make web a beautiful place and life 'simple'.
<br/>
<br/>
With a diverse skill set encompassing web development, app development, coding, programming, data mining, database management, embedded systems, and data analysis, I'm passionate about using these skills to drive meaningful change. 
<br/><br/>
Proficient in tools and languages such as Django, React, HTML, CSS, Python, C++, C, GitHub, Git, Java, Linux, Unix, SQL and Arduino programming, I'm committed to creating innovative solutions that merge technology with creativity. 
<br/>
</div>

<br/>
<br/>

<hr className="hr"/>

<br/>


<center>
  <div className='gap-10 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 mr-5'>
    <div className='my-8 ml-2 '>
    <div className='white'>
  <span className='title'>Blogs</span><br/><br/>
  <div className="sentence grey">Visit my Blog Website to read the latest & featured Blogs.</div><br/>
  <br/>
  <a className='Button pointer black' href='https://nabeel-r.vercel.app'>View</a>
  </div>
  
  </div>
 

  <div className='my-8 ml-2 '>
  <div className='white'>
<span className='title'>Check it out !!</span> <span className='sentence grey'> <br/><br/>Check out SQL Queries, Embedded System Assignments & Lab work performed by Me.</span><br/><br/><br/>
<Link className='Button pointer black' to='/Projects'>View</Link>
 </div>

  </div>
  </div>
  </center>

<br/>

<hr className="hr"/>

<br/>

<div className="flex flex-col justify-center px-4 mr-5 py-5 mx-auto md:p-8 ">
                    <div className="preventhighlight space-y-10">
                        <details className="accordionbackground hover:ring-white pointer w-full rounded-lg ring-1 ring-[#313131]">
                            <summary className="px-4 py-6 white hovering">
                            Industrial Skills
                            </summary>
                            <div className="white px4 py-6 pt-0 ml-4 -mt-4 text-gray-600 marginright">
                           <br/>
                            <div>    
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Web Development
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> App Development
                          <br />
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> FullStack Development
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Embedded Systems
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Machine Learning
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Data Mining
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Data Analysis
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Programming
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Coding
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Database Management System
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Data Structures & Algorithms
                           </div>
                           </div>
                        </details>
                    </div>
                </div>
     
    
<div className="flex flex-col justify-center px-4 py-5 mr-5 mx-auto md:p-8 ">
                    <div className="preventhighlight space-y-10">
                        <details className="accordionbackground hover:ring-white pointer w-full rounded-lg ring-1 ring-[#313131]">
                            <summary className="px-4 py-6 white hovering">
                            Tools & Programming Languages
                            </summary>
                            <div className="white px4 py-6 pt-0 ml-4 -mt-4 text-gray-600 marginright">
                           <br/>
                            <div>    
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Django
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> React
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Unix / Linux
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> HTML & CSS
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Git / Github
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> C / C++
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Java
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Python
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Arduino Programming
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> SQL
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Tableau
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Looker Studio (formerly Google Data Studio)
                           </div>

                           </div>
                        </details>

                    </div>
                </div>


</div>

        </div>
        </div>
      </div>     {/* End of page grid */}


</>
    
   
  );
}

export default Home;
